import axios from 'axios';
import ApiError from './error';

const PaymentService = {
  getAll() {
    return axios.get('paymentMethod').catch((error) => {
      throw new ApiError(error);
    });
  },

  get(id) {
    return axios.get(`paymentMethod/${id}`).catch((error) => {
      throw new ApiError(error);
    });
  },

  payment({ orderUuid, paymentMethodId, paymentData }) {
    return axios.post('payment', { orderUuid, paymentMethodId, paymentData }).catch((error) => {
      throw new ApiError(error);
    });
  },

  verifoneInit({ paymentMethodId }) {
    return axios.post('payment', { paymentMethodId }).catch((error) => {
      throw new ApiError(error);
    });
  },

  verifone3dSecure({
    sessionId, paymentMethodId, orderUuid, encryptedCard, publicKeyAlias,
  }) {
    return axios.post('payment', {
      sessionId, paymentMethodId, orderUuid, encryptedCard, publicKeyAlias,
    }).catch((error) => {
      throw new ApiError(error);
    });
  },

  verifonePayment({
    paymentMethodId, orderUuid, encryptedCard, publicKeyAlias, jwt, threedsLookupData,
  }) {
    return axios.post('payment', {
      paymentMethodId, orderUuid, encryptedCard, publicKeyAlias, jwt, threedsLookupData,
    }).catch((error) => {
      throw new ApiError(error);
    });
  },
};

export default PaymentService;
